import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/HeritageUnit`
//#region HeritageUnit
const GetStatusList = `${apiUrl}/GetStatus`
const GetUnitList = `${apiUrl}`
const GetOtherUnits = `${apiUrl}/GetOtherUnits`
const GetListByUser = `${apiUrl}/GetListByUser`
const GetCoordList = `${apiUrl}/GetCoordList`
const DeleteUnit = (id: number) => `${apiUrl}/${id}`
//#endregion
///文保单位列表实体，另外加增删改权限控制
export interface UnitListData {
    [key: string]: any
    Id: number
    UnitId: number
    UnitCode: string
    UnitName: string
    LevelId: number
    LevelName: string
    BatchId: number
    BatchName: string
    ClassifyId: number
    ClassifyName: string
    SubClassifyId: number
    SubClassifyName: string
    StatisticAgeId: number
    StatisticAgeName: string
    PublishAge: string
    AreaType: number
    AreaTypeName: string
    CityId: number
    CountyId: number
    CityName: string
    CountyName: string
    AreaCode: string
    AreaName: string
    Status: number
    UpdateDate: Date
    Inactive: boolean

    BackId: number
    BackUser: string
    BackDate: Date
    BackComments: string

    IsOwner: boolean

    DoEdit: boolean
    DoDel: boolean
    DoAudit: boolean
}
///其他文保单位列表实体，另外加增删改权限控制
export interface OtherUnitListData {
    [key: string]: any
    Id: number
    UnitId: number
    UnitCode: string
    UnitName: string
    LevelId: number
    LevelName: string
    BatchId: number
    BatchName: string
    InstituteTypeId: number
    InstituteTypeName: string
    InstituteLevelId: number
    InstituteLevelName: string
    AreaType: number
    AreaTypeName: string
    CityId: number
    CountyId: number
    CityName: string
    CountyName: string
    AreaCode: string
    AreaName: string
    Status: number
    UpdateDate: Date
    Inactive: boolean

    BackId: number
    BackUser: string
    BackDate: Date
    BackComments: string

    IsOwner: boolean
    DoEdit: boolean
    DoDel: boolean
    DoAudit: boolean
}
export interface UnitAuditData {
    [key: string]: any
    Id: number
    UnitId: number
    ListId: number
    UnitCode: string
    UnitName: string

    AuditResult: boolean
    Comments: string
}
export interface PopUnitFilter {
    Page: number
    PageSize: number
    CityId: number
    CountyId: number
    LevelId: number
    Keyword: string
}
export interface PopUnitData {
    [key: string]: any
    ListId: number
    UnitId: number
    UnitCode: string
    UnitName: string
    CityId: number
    CityName: string
    CountyId: number
    CountyName: string
    ClassId: number
    ClassName: string
    LevelId: number
    LevelName: string
    BatchId: number
    BatchName: string
    PlanId: number
    PlanName: string
}
export const emptyPopUnitData: PopUnitData = {
    ListId: 0,
    UnitId: 0,
    UnitCode: '',
    UnitName: '',
    CityId: 0,
    CityName: '',
    CountyId: 0,
    CountyName: '',
    ClassId: 0,
    ClassName: '',
    LevelId: 0,
    LevelName: '',
    BatchId: 0,
    BatchName: '',
    PlanId: 0,
    PlanName: ''
}
export const getStatusList = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetStatusList,
        params: { type: firstType }
    })
}
export const getUnitList = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetUnitList,
        params: param
    })
}
export const getOtherUnits = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetOtherUnits,
        params: param
    })
}

export const getListByUser = (filter: PopUnitFilter) => {
    return tryAxios({
        method: 'get',
        url: GetListByUser,
        params: filter
        // {
        //     page: filter.Page,
        //     pageSize: filter.PageSize,
        //     cityId: filter.CityId,
        //     CountyId: filter.CountyId,
        //     level: filter.LevelId,
        //     keyword: filter.Keyword
        // }
    })
}
export const removeUnit = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: DeleteUnit(id)
    })
}
export const getCoordList = (filter: any) => {
    return tryAxios({
        method: 'get',
        url: GetCoordList,
        params: filter
    })
}
